module.exports = __webpack_public_path__ + "img/logo_spes_large.3d763533.svg";